export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/recomendations/get/${id}`,
    });
  },
  find(filterParams) {
    return client.request({
      method: 'get',
      url: '/recomendations',
      params: { ...filterParams },
    });
  },
  create(payload) {
    return client.request({
      method: 'post',
      url: '/recomendations',
      data: payload,
    });
  },
  patch(id, payload) {
    return client.request({
      method: 'put',
      url: `/recomendations/${id}`,
      data: payload,
    });
  },
});
